import React, { FC, useState, ChangeEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { userActions } from '../../redux/slices/userSlice';
import userService from '../../services/UserServices';
import { Box, TextField, Button } from '@mui/material';

export const formatValue = (value: string) => {
  let regex2;
  let regex1;
  if (value.length >= 2) {
    regex1 = /[^0-9]/g;
    regex2 = /[^0-9k]/g;
    const valueToVerify = value.slice(0, -1).replace(regex1, '');
    const verifyingDigit = value.charAt(value.length - 1).replace(regex2, '');
    const cleanValue = valueToVerify + verifyingDigit;
    return `${cleanValue.slice(0, -1)}-${cleanValue.charAt(cleanValue.length - 1)}`;
  }
  return value;
};

export const dgv = (T: number) => {
  let M = 0;
  let S = 1;
  // eslint-disable-next-line no-param-reassign
  for (; T; T = Math.floor(T / 10)) {
    S = (S + (T % 10) * (9 - (M % 6))) % 11;
    M += 1;
  }
  return S ? S - 1 : 'k';
};

const AddRUT: FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [phone, setPhone] = useState('569');
  const [phoneError, setPhoneError] = useState('');
  const changePhone = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const regex = /^[0-9\b]+$/;
    if (event.target.value === '' || regex.test(event.target.value)) {
      setPhone(event.target.value);
      setPhoneError('');
    } else {
      setPhoneError('Error al ingresar el número');
    }
  };
  const activated = () => {
    navigate('/home');
  };
  const token = useSelector((state: RootState) => state.user.token);
  const patchPhone = async () => {
    const response = await userService.updatePhone(phone, token);
    if (response) {
      const { user } = response;
      user.token = response.token;
      dispatch(userActions.login(user));
      dispatch(userActions.redirect({ redirect: 'false' }));
      activated();
    }
  };
  return (
    <Box sx={{ minWidth: '320px', display: 'inline-block', padding: '5%' }}>
      <Box sx={{ width: '100%', marginY: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <h2 className="App-logo-text">COMPLETA TU INFORMACION</h2>
      </Box>
      <TextField
        sx={{ width: '100%', marginY: '2%' }}
        label="Telefono celular"
        variant="outlined"
        value={phone}
        inputProps={{ inputMode: 'numeric' }}
        onChange={changePhone}
        error={phoneError !== ''}
        helperText={phoneError}
      />
      <Button
        onClick={patchPhone}
        size="large"
        sx={{ width: '100%', marginY: '2%', fontWeight: 'bold', borderRadius: '50px' }}
        disabled={phone === '' || phoneError !== ''}
        variant="contained">
        AGREGAR TELEFONO
      </Button>
    </Box>
  );
};

export default AddRUT;
